import { useConfigContext } from 'contexts/config';

export const useUnquantizeAmount = () => {
  const { ethQuantum } = useConfigContext();

  return (amount: bigint) => amount * ethQuantum;
};
